import PropTypes from 'prop-types';

import classNames from 'classnames';

import { formatPrice } from '@spotahome/soyuz-currency';

import Tooltip from '../Tooltip';
import InfoIcon from '../icons/InfoIcon';

import Link from '../Link';

import IncludedBadge from './IncludedBadge';

import styles from './PaymentTimelineItem.module.scss';

const PaymentTimeLineItem = ({
  title,
  subtitle = null,
  value,
  valueSubtitle = null,
  currencyCode = null,
  valueWithoutOffer = null,
  tooltipText = null,
  onValueClick = null,
  included = false,
  includedCopy = null
}) => {
  const ValueContainer = onValueClick ? Link : 'div';
  const valueContainerProps = onValueClick
    ? {
        onClick: onValueClick
      }
    : {};

  const hasOffer = Boolean(valueWithoutOffer && valueWithoutOffer !== value);

  const valueClasses = classNames('payment-timeline-item__value', {
    [styles['payment-timeline-item__value--with-offer']]: hasOffer
  });

  const valueToRender =
    typeof value === 'number' ? formatPrice(value, currencyCode) : value;

  return (
    <div className={styles['payment-timeline-item']}>
      <div>
        <div className={styles['payment-timeline-item__title']}>
          {title}
          {tooltipText && (
            <Tooltip
              className={styles['payment-timeline-item__title-tooltip']}
              color="blue-indigo"
              position="bottom"
              tooltip={tooltipText}
            >
              <InfoIcon />
            </Tooltip>
          )}
        </div>
        {subtitle && <div>{subtitle}</div>}
      </div>
      {!included && (
        <>
          {hasOffer && (
            <div
              className={styles['payment-timeline-item__value--without-offer']}
            >
              {formatPrice(valueWithoutOffer, currencyCode)}
            </div>
          )}
          <div className={styles['payment-timeline-item__value-container']}>
            <ValueContainer {...valueContainerProps} className={valueClasses}>
              {valueToRender}
            </ValueContainer>
            {valueSubtitle && (
              <div className={styles['payment-timeline-item__value-subtitle']}>
                {valueSubtitle}
              </div>
            )}
          </div>
        </>
      )}
      {included && (
        <IncludedBadge
          className={styles['payment-timeline-item__value-container']}
          includedCopy={includedCopy}
          valueSubtitle={valueSubtitle}
        />
      )}
    </div>
  );
};

PaymentTimeLineItem.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.number
  ]).isRequired,
  valueSubtitle: PropTypes.string,
  currencyCode: PropTypes.string,
  valueWithoutOffer: PropTypes.string,
  tooltipText: PropTypes.string,
  onValueClick: PropTypes.func,
  included: PropTypes.bool,
  includedCopy: PropTypes.string
};

export default PaymentTimeLineItem;
